<template>
    <section>
        <div class="box">
            <div class="column is-3">
                <b-field>
                    <b-input :placeholder="$t('MONTAGENS.BUSCARCLIENTE')"
                            v-model="procurarCliente"
                            icon="magnify"
                            @input="loadAsyncData()"></b-input>
                </b-field>
            </div>
        </div>
        <b-table :data="model"
                 :loading="loading"
                 :bordered="true"
                 striped
                 hoverable                 
                 :aria-next-label="$t('SISTEMA.PROXPAGINA')"
                 :aria-previous-label="$t('SISTEMA.PAGINAANTERIOR')"
                 :aria-page-label="$t('SISTEMA.PAGINA')"
                 :aria-current-label="$t('SISTEMA.PAGINAATUAL')"
                 :opened-detailed="detalhesAbertos"
                 :show-detail-icon="true"
                 custom-detail-row
                 detail-transition="fade"
                 detailed
                 detail-key="clienteCodigoExterno"                                  
                 paginated
                 :per-page="perPage"
                 :total="total">

                <b-table-column v-slot="props" field="clienteCodigoExterno" :label="$t('SISTEMA.CODIGO')" >
                    {{ props.row.clienteCodigoExterno }}
                    <b-icon v-if="props.row.vendaVinculadaId > 0"  icon="link"
                                        size="is-small"                                    
                                        :title="$t('GUIALIST.ATENDIMENTOVINCULADO')"
                                        type="is-link"></b-icon>                                                                                                       
                            <b-icon v-if="props.row.tipo == 2"
                                            icon="cog"
                                            size="is-small"                                    
                                            :title="$t('VENDAS.ASSISTENCIA')"></b-icon>      
                            <b-icon v-if="props.row.tipo == 3"
                                            icon="tools"
                                            size="is-small"                                    
                                            :title="$t('VENDAS.MOSTRUARIO')"></b-icon>                           
                </b-table-column>

                <b-table-column v-slot="props" field="CodigoContrato" :label="$t('SISTEMA.CODIGOCONTRATO')" >
                    <template v-if="props.row.codigoContrato">
                        {{ props.row.codigoContrato }}
                    </template>
                </b-table-column>

                <b-table-column v-slot="props" field="ClienteNome" :label="$t('SISTEMA.CLIENTE')" >
                    {{ props.row.clienteNome }}
                
                </b-table-column>

                <b-table-column v-slot="props" field="Conferente" :label="$t('SISTEMA.CONFERENTE')" >
                    {{ props.row.funcionarioConferenteNome }}
                </b-table-column>

                <b-table-column v-slot="props" field="Previsao" :label="$t('MONTAGENS.PREVISAOTERMINO')" >
                    {{ props.row.dataHoraPrazoInstalacao ? $moment(props.row.dataHoraPrazoInstalacao).format("DD/MM/YYYY") : ''  }} 
                </b-table-column>                

                <b-table-column v-slot="props" width="10%">
                    <b-button class="ml-1  is-small " icon-left="cog" @click="incluirAssistencia(props.row)">
                        {{$t('MONTAGENS.NOVAASSISTENCIA')}}
                    </b-button>
                </b-table-column>

                <template slot="detail" slot-scope="props">
                <tr v-for="item in props.row.assistencias" :key="item.id">                                        
                    <td colspan="4" class="has-text-centered">{{ item.observacao}}</td>
                    <td colspan="2" class="has-text-centered"> Aguardando Conferente</td>
                    <td colspan="1" class="has-text-centered">
                        <b-button :title="$t('SISTEMA.EDITAR')" class="ml-1  is-small is-primary" @click="editarAssistencia(item)"  icon-left="pencil"></b-button>   
                    </td>
                </tr>
                </template>               
           
        </b-table>

        <nav class="level">
                <div class="level-item">
                    <p class="buttons">
                        <b-button type="is-danger"
                                  native-type="button"
                                  icon-left="close-circle"
                                  @click="$router.back();">
                            {{$t('SISTEMA.VOLTAR')}}
                        </b-button>
                    </p>
                </div>
            </nav>
    </section>
</template>

<script>
    import debounce from 'lodash/debounce'
    import { mapState, mapGetters } from 'vuex'
    import modalCadastroAssistenciaPosVenda from '@/components/posvenda/modalCadastroAssistenciaPosVenda'

    export default {
        data(){
            return {
                model: [],
                total: 0,
                loading: false,
                id: null,
                page: 1,
                perPage: 50,
                procurarCliente: null,
            }
        },
        computed: {
            ...mapState([
                'unidadeId'
            ]),
            ...mapGetters([
                'isInRole'
            ]),
          
            detalhesAbertos() {
                return this.model.map(item => item.clienteCodigoExterno);
            }
                       
        },
        methods: {

              
            loadAsyncData: debounce(async function () {
                this.page = 1
                this.model = []
                
                await this.listarMonstagens();                
                
                const pageCount = Math.ceil(this.model.length / this.perPage);
                this.total = this.perPage * pageCount;
            }, 500),
            onPageChange(page) {
                this.page = page
            },
            listarMonstagens(){
                this.loading = true;
                const params = [
                    `unidadeId=${this.unidadeId}`,
                ];

                if(this.procurarCliente){
                    params.push(`procurarCliente=${this.procurarCliente}`)
                }

                return this.$http.get(`/api/posvenda/RetornarMontagens?${params.join('&')}`)
                        .then(res => res.data)
                        .then(data => {
                        this.model.push(...data);
                    })
                    .catch((error) => {
                        this.model = []
                        throw error
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },

            editarAssistencia(item){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCadastroAssistenciaPosVenda,
                    props: {
                        montador: true,
                        id: item.id,
                        posvendaid: item.posVendaId,
                        clienteCodigoExterno: item.clienteCodigoExterno,
                        guiaId: item.guiaId                       
                    },
                    events: {
                        carregarAssistencias: this.loadAsyncData                        
                    },
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },               
            incluirAssistencia(data){
                this.$buefy.modal.open({
                    parent: this,
                    component: modalCadastroAssistenciaPosVenda,
                    props: {
                        montador: true,
                        posvendaid: data.id,
                        guiaId: data.guiaId,
                        clienteCodigoExterno: data.clienteCodigoExterno,
                        funcionarioConferenteId: data.funcionarioConferenteId,
                    },
                    events: {
                        carregarAssistencias: this.loadAsyncData                        
                    },                    
                    hasModalCard: true,
                    trapFocus: true,
                    fullScreen:true
                })
            },
        },
        async mounted() {
            await this.loadAsyncData();
        }
    }
</script>